module.exports = "<h1>Single Product</h1>\n"